export default {
    title: 'TRENDONE Universe',
    pageTitle: 'ADMIN - TRENDONE-UNIVERSE'
}
